export default __webpack_public_path__ + "static/media/google-icon.d625b6db.svg";